import React from 'react';

import DataTable, { EmptyState } from '../DataTable';

import { formatDateTime } from '../../utils';

// Row numbering is per-page (keyset pagination has no absolute page offset).
function VirtualAccountTable(props) {
  const {
    rows,
    loading,
    onRowClick = () => {},
    card = true,
    footer,
    error,
    onRetry,
    page,
    total,
    onPageChange,
  } = props;

  return (
    <DataTable
      card={card}
      loading={loading}
      minWidth={900}
      footer={footer}
      page={page}
      total={total}
      onPageChange={onPageChange}
    >
      <thead className="text-primary">
        <tr>
          <th>No.</th>
          <th>Created</th>
          <th>Acc. Number</th>
          <th>Acc Name</th>
          <th>Type</th>
          <th>Provider</th>
          <th>Bank</th>
          <th>Disco</th>
          <th>Active</th>
        </tr>
      </thead>
      {!loading && error ? (
        <EmptyState
          colSpan={9}
          icon={false}
          heading="Something went wrong"
          message={error}
          actionLabel="Retry"
          onAction={onRetry}
        />
      ) : (
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              onClick={() => onRowClick(row)}
              key={row.id}
              style={{ cursor: 'pointer' }}
            >
              <td>{loading ? '—' : rowIndex + 1}</td>
              <td>{formatDateTime(row.created_at)}</td>
              <td>{row.acc_num}</td>
              <td>{row.acc_name}</td>
              <td>{row.account_type}</td>
              <td>{row.provider}</td>
              <td>{row.bank}</td>
              <td>{row.disco}</td>
              <td>{row.active ? 'YES' : 'NO'}</td>
            </tr>
          ))}
        </tbody>
      )}
    </DataTable>
  );
}

export default VirtualAccountTable;
